<template>
	<div class="themactivities">
		<headerview :cur="3"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipcon :title="'专题活动'" :name="'专题活动'" :imgtype="'1'" width="2.05"></tipcon>
				</div>
				
				<div class="listcon">
					<div class="signle" v-for="(item,index) in list" :key="index">
						<div class="imgcon">
							<el-image fit='cover' :src="$fileAccessHttpUrl(item.breviaryMap_dictText)" alt="">
								<div slot="error" class="image-slot f-row-c h-100 bg-gray1 color-gray">
									{{item.breviaryMap_dictText?'图片加载失败':'暂无上传图片'}}
								</div>
							</el-image>
						</div>
						<div class="leftcon">
							<div class="title overfh" :title="item.title">{{item.title || ''}}</div>
							<div class="inform" :title="item.brief || ''">{{item.brief || ''}}</div>
							<div class="btncon">
								<div class="btn" @click="toseethemact(item)">查看专题</div>
							</div>
						</div>
					</div>
					
				</div>
				
				<!-- 分页 -->
				<div class="">
					<div is='footPage' class="zhini-pagination"
					  :currentPage="pageNo"
					  :totalPage="total"
					  @pageNum="pageNum"  :pagesize='pageSize'></div>
				</div>
				
			</div>
				
		</div>		
		
		<footview></footview>
		
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import footPage from '../../../components/footpage/footpage.vue'

export default {
  components: {
	  tipcon,
 	  footPage,
  },
  data: function() {
		return {
			list:[],
		    pageNo:1,
		    total:5,
		    pageSize:3,
					  
		};
  },
  
  mounted() {
  		
		this.getSpecial()
		this.$onScrollT()
  },
  
  methods: {
	    //跳转详情
	    toseethemact(item){
			this.$router.push({ path: '/themactdetail?id=' + item.id });
		},
		
		//专题活动
		getSpecial(){
			this.$get(`web/specialActivity/activityList?pageSize=3&pageNo=${this.pageNo}&column=createTime&order=desc`).then(res=>{
				  if(res.success){
						this.total = res.result.total
						this.list = res.result.records
				  }
			})
		},
		
		//过滤富文本
		gethypertext(str){
			if(str == null){
				return "";
			}
			var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
			              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
			str = str.substring(0,450);
			return str;
		},
	  
	    //分页
		pageNum(e) {
			console.log('pageNum',e)
			this.pageNo = e;
			this.$onScrollT()
			this.getSpecial()
		},
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.themactivities{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.listcon{
				
				.signle{
					margin-top: 40px;
					height: 390px;
					background: #FFFFFF;
					border: 1px solid #E5E5E5;
					display: flex;
					padding-left: 20px;
					padding-right: 20px;
					.imgcon{
						display: flex;
						align-items: center;
						justify-content: center;
						.el-image{
							width: 544px;
							height: 351px;
						}
					}
					.leftcon{
						flex: 1;
						display: flex;
						flex-direction: column;
						// justify-content: space-around;
						margin-left: 20px;
						.title{
							font-size: 18px;
							font-weight: 400;
							color: #333333;
							margin-top: 20px;
						}
						.inform{
							font-size: 16px;
							font-weight: 400;
							color: #666666;
							margin-top: 20px;
							height: 238px;
							overflow: hidden;
							margin-bottom: 10px;
						}
						.btncon{
							.btn{
								cursor: pointer;
								width: 103px;
								height:33px;
								line-height:33px;
								text-align: center;
								background: #FA9E1E;
								border-radius:14px;
								font-size: 16px;
								font-weight: 400;
								color: #FFFFFF;
							}
						}
					}
				}
								
			}
			
			
		}
			
	}		
	
	
	
}

</style>
